import React from 'react';
import Mountains from '~/shared/svg/Mountains';
import { getLcn } from '~/utils/labeled-classnames';

export default function Footer() {
  const lcn = getLcn({
    footer: 'pt-44'
  });

  return (
    <div className={lcn.footer}>

      <Mountains />
    </div>
  );
}; 